import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const IconEyeFill = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.002 15.577c1.133 0 2.096-.397 2.887-1.19.792-.793 1.188-1.756 1.188-2.89 0-1.132-.397-2.095-1.19-2.886-.793-.792-1.756-1.188-2.89-1.188-1.132 0-2.095.397-2.886 1.19-.792.793-1.188 1.756-1.188 2.89 0 1.132.397 2.095 1.19 2.886.793.792 1.756 1.188 2.89 1.188ZM12 14.2c-.75 0-1.387-.262-1.912-.787A2.604 2.604 0 0 1 9.3 11.5c0-.75.263-1.387.787-1.912A2.604 2.604 0 0 1 12 8.8c.75 0 1.387.262 1.912.787.525.526.788 1.163.788 1.913s-.262 1.387-.787 1.912A2.604 2.604 0 0 1 12 14.2Zm0 4.3c-2.105 0-4.03-.562-5.776-1.685a12.571 12.571 0 0 1-4.18-4.432 1.763 1.763 0 0 1-.182-.434 1.758 1.758 0 0 1 .182-1.332 12.573 12.573 0 0 1 4.18-4.432C7.97 5.062 9.894 4.5 12 4.5c2.105 0 4.03.562 5.776 1.685a12.573 12.573 0 0 1 4.18 4.432c.083.144.144.289.183.434a1.76 1.76 0 0 1-.183 1.332 12.571 12.571 0 0 1-4.18 4.432C16.031 17.938 14.106 18.5 12 18.5Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconEyeFill;
